import { OfficialPortfolioProject } from '../types';

export const INITIAL_OFFICIAL_PORTFOLIO: OfficialPortfolioProject[] = [
  {
    id: 'port_dalamancamfilmi',
    title: 'Dalaman Cam Filmi',
    slug: 'dalamancamfilmi',
    category: 'Oto & Cam Filmi',
    description: 'Otomotiv cam filmi, bina mimari cam filmi ve güvenlik filmi uygulamaları için özel dijital vitrin ve kurumsal web sitesi.',
    url: 'https://www.dalamancamfilmi.com/',
    thumbnail: 'https://images.unsplash.com/photo-1617814076367-b759c7d7e738?q=80&w=800&auto=format&fit=crop',
    featured: true,
    projectType: 'website',
    technologies: ['React', 'SEO Altyapısı', 'Mobil Uyumlu', 'WhatsApp İletişim'],
    isOfficialPortfolio: true,
    status: 'ACTIVE',
    sortOrder: 1,
    clientName: 'Dalaman Cam Filmi',
    createdAt: 1705000000000,
    updatedAt: 1710000000000,
  },
  {
    id: 'port_airportestate',
    title: 'Airport Estate',
    slug: 'airportestate',
    category: 'Gayrimenkul & Emlak',
    description: 'Havalimanı ve sahil lokasyonlu lüks gayrimenkul portföyü, villa ve arsa ilanları için kapsamlı emlak platformu.',
    url: 'https://www.airportestate.com/',
    thumbnail: 'https://images.unsplash.com/photo-1512917774080-9991f1c4c750?q=80&w=800&auto=format&fit=crop',
    featured: true,
    projectType: 'website',
    technologies: ['İlan Yönetimi', 'Filtreleme Sistemi', 'Çoklu Dil', 'Hızlı Harita'],
    isOfficialPortfolio: true,
    status: 'ACTIVE',
    sortOrder: 2,
    clientName: 'Airport Estate Real Estate',
    createdAt: 1705100000000,
    updatedAt: 1710100000000,
  },
  {
    id: 'port_esfayangin_web',
    title: 'ESFA Yangın',
    slug: 'esfayangin',
    category: 'Yangın Güvenliği & Mühendislik',
    description: 'Endüstriyel yangın söndürme sistemleri, periyodik denetim ve can güvenliği mühendisliği kurumsal web portalı.',
    url: 'http://www.esfayangin.com/',
    thumbnail: 'https://images.unsplash.com/photo-1581092160607-ee22621dd758?q=80&w=800&auto=format&fit=crop',
    featured: true,
    projectType: 'website',
    technologies: ['Kurumsal Web', 'Teknik Katalog', 'Teklif Talep Formu', 'SEO'],
    isOfficialPortfolio: true,
    status: 'ACTIVE',
    sortOrder: 3,
    clientName: 'ESFA Yangın Güvenlik Sistemleri',
    createdAt: 1705200000000,
    updatedAt: 1710200000000,
  },
  {
    id: 'port_esfayangin_mobile',
    title: 'ESFA Yangın – Özel Mobil Saha Takip Uygulaması',
    slug: 'esfa-yangin-mobil-uygulama',
    category: 'Özel Mobil Yazılım',
    description: 'Saha denetim ekipleri için periyodik yangın tüpü QR kod tarama, bakım kontrolü ve anlık raporlama mobil uygulaması.',
    thumbnail: 'https://images.unsplash.com/photo-1551650975-87deedd944c3?q=80&w=800&auto=format&fit=crop',
    featured: true,
    projectType: 'mobile_app',
    technologies: ['React Native', 'QR Kod Entegrasyonu', 'Çevrim Dışı Mod', 'Cloud Sync'],
    isOfficialPortfolio: true,
    status: 'ACTIVE',
    sortOrder: 4,
    clientName: 'ESFA Yangın A.Ş.',
    createdAt: 1705250000000,
    updatedAt: 1710250000000,
  },
  {
    id: 'port_aggaraj',
    title: 'AG Garaj',
    slug: 'aggaraj',
    category: 'Oto Servis & Detailing',
    description: 'Otomotiv bakım, pasta cila, boya koruma ve periyodik servis hizmetleri için etkileyici dijital vitrin.',
    url: 'https://aggaraj.com/',
    thumbnail: 'https://images.unsplash.com/photo-1486006920555-c77dce18193b?q=80&w=800&auto=format&fit=crop',
    featured: true,
    projectType: 'website',
    technologies: ['Galeri & Portfolyo', 'Online Randevu', 'WhatsApp Entegrasyonu'],
    isOfficialPortfolio: true,
    status: 'ACTIVE',
    sortOrder: 5,
    clientName: 'AG Garaj Otomotiv',
    createdAt: 1705300000000,
    updatedAt: 1710300000000,
  },
  {
    id: 'port_dentalclinicortaca',
    title: 'Dental Clinic Ortaca',
    slug: 'dentalclinicortaca',
    category: 'Sağlık & Diş Kliniği',
    description: 'Estetik diş hekimliği, gülüş tasarımı ve implant tedavileri için hasta randevu ve bilgilendirme platformu.',
    url: 'https://dentalclinicortaca.com/',
    thumbnail: 'https://images.unsplash.com/photo-1629909613654-28e377c37b09?q=80&w=800&auto=format&fit=crop',
    featured: true,
    projectType: 'website',
    technologies: ['Çok Dilli (TR/EN)', 'Hasta Randevu', 'Tedavi Rehberi', 'SSL'],
    isOfficialPortfolio: true,
    status: 'ACTIVE',
    sortOrder: 6,
    clientName: 'Dental Clinic Ortaca',
    createdAt: 1705400000000,
    updatedAt: 1710400000000,
  },
  {
    id: 'port_easycarhiredalaman',
    title: 'Easy Car Hire Dalaman',
    slug: 'easycarhiredalaman',
    category: 'Araç Kiralama (Rent a Car)',
    description: 'Dalaman Havalimanı teslimatlı araç kiralama, güncel filo listesi ve online ön rezervasyon portalı.',
    url: 'https://easycarhiredalaman.com/',
    thumbnail: 'https://images.unsplash.com/photo-1549317661-bd32c8ce0db2?q=80&w=800&auto=format&fit=crop',
    featured: true,
    projectType: 'website',
    technologies: ['Filo Yönetimi', 'Tarih & Fiyat Hesaplama', 'Çoklu Para Birimi'],
    isOfficialPortfolio: true,
    status: 'ACTIVE',
    sortOrder: 7,
    clientName: 'Easy Car Hire Dalaman',
    createdAt: 1705500000000,
    updatedAt: 1710500000000,
  },
  {
    id: 'port_lorryhome',
    title: 'Lorry Home',
    slug: 'lorryhome',
    category: 'Mobilya & Dekorasyon',
    description: 'Özel üretim ahşap mobilya, modern ev dekorasyonu ve iç mimari koleksiyonları dijital ürün kataloğu.',
    url: 'https://lorryhome.com/',
    thumbnail: 'https://images.unsplash.com/photo-1555041469-a586c61ea9bc?q=80&w=800&auto=format&fit=crop',
    featured: true,
    projectType: 'website',
    technologies: ['Ürün Kataloğu', 'Yüksek Çözünürlüklü Galeri', 'Teklif Modülü'],
    isOfficialPortfolio: true,
    status: 'ACTIVE',
    sortOrder: 8,
    clientName: 'Lorry Home Design',
    createdAt: 1705600000000,
    updatedAt: 1710600000000,
  },
  {
    id: 'port_motopowerdalaman',
    title: 'Moto Power Dalaman',
    slug: 'motopowerdalaman',
    category: 'Motosiklet & Ekipman',
    description: 'Sıfır ve ikinci el motosiklet, ATV, kask, mont ve sürücü güvenlik ekipmanları geniş ürün kataloğu.',
    url: 'https://www.motopowerdalaman.com/',
    thumbnail: 'https://images.unsplash.com/photo-1558981403-c5f9899a28bc?q=80&w=800&auto=format&fit=crop',
    featured: true,
    projectType: 'website',
    technologies: ['Filtrelenebilir Ürünler', 'Stok & Fiyat Bilgisi', 'WhatsApp Sipariş'],
    isOfficialPortfolio: true,
    status: 'ACTIVE',
    sortOrder: 9,
    clientName: 'Moto Power Dalaman',
    createdAt: 1705700000000,
    updatedAt: 1710700000000,
  },
  {
    id: 'port_bmotoozelservis',
    title: 'B Moto Özel Servis',
    slug: 'bmotoozelservis',
    category: 'Motosiklet Servisi',
    description: 'Motosiklet periyodik bakım, bilgisayarlı arıza tespiti ve orijinal yedek parça tedarik servisi sitesi.',
    url: 'https://www.bmotoozelservis.com/',
    thumbnail: 'https://images.unsplash.com/photo-1568772585407-9361f9bf3a87?q=80&w=800&auto=format&fit=crop',
    featured: false,
    projectType: 'website',
    technologies: ['Hızlı İletişim', 'Hizmet Kataloğu', 'Mobil Uyumlu'],
    isOfficialPortfolio: true,
    status: 'ACTIVE',
    sortOrder: 10,
    clientName: 'B Moto Özel Servis',
    createdAt: 1705800000000,
    updatedAt: 1710800000000,
  },
  {
    id: 'port_dalamanhaliyikama',
    title: 'Dalaman Halı Yıkama',
    slug: 'dalamanhaliyikama',
    category: 'Temizlik & Hizmet',
    description: 'Endüstriyel tesislerde halı, koltuk ve yorgan yıkama servis rezervasyonu ve fiyat hesaplama web sitesi.',
    url: 'https://dalamanhaliyikama.com/',
    thumbnail: 'https://images.unsplash.com/photo-1581578731548-c64695cc6952?q=80&w=800&auto=format&fit=crop',
    featured: false,
    projectType: 'website',
    technologies: ['Servis Çağrı Butonu', 'Fiyat Listesi', 'Yerel SEO'],
    isOfficialPortfolio: true,
    status: 'ACTIVE',
    sortOrder: 11,
    clientName: 'Dalaman Halı Yıkama',
    createdAt: 1705900000000,
    updatedAt: 1710900000000,
  },
  {
    id: 'port_dalamanyolyardim',
    title: 'Dalaman Yol Yardım',
    slug: 'dalamanyolyardim',
    category: 'Oto Kurtarma & Yol Yardım',
    description: '7/24 oto kurtarıcı, akü takviye, yakıt desteği ve acil yol yardım tek dokunuşla çağrı web sitesi.',
    url: 'https://dalamanyolyardim.com/',
    thumbnail: 'https://images.unsplash.com/photo-1619642751034-765dfdf7c58e?q=80&w=800&auto=format&fit=crop',
    featured: false,
    projectType: 'website',
    technologies: ['Acil Arama', 'Harita & Konum Gönderme', 'Hızlı Yükleme'],
    isOfficialPortfolio: true,
    status: 'ACTIVE',
    sortOrder: 12,
    clientName: 'Dalaman 7/24 Yol Yardım',
    createdAt: 1706000000000,
    updatedAt: 1711000000000,
  },
  {
    id: 'port_yataganyolyardim',
    title: 'Yatağan Yol Yardım',
    slug: 'yataganyolyardim',
    category: 'Oto Kurtarma & Yol Yardım',
    description: 'Yatağan ve çevre otoyolları için 7/24 acil çekici ve kaza kurtarma servisi mobil odaklı web sitesi.',
    url: 'https://yataganyolyardim.com/',
    thumbnail: 'https://images.unsplash.com/photo-1544829099-b9a0c07fad1a?q=80&w=800&auto=format&fit=crop',
    featured: false,
    projectType: 'website',
    technologies: ['Tek Tuşla Çağrı', 'Yerel Arama Optimizasyonu', 'Mobil Öncelikli'],
    isOfficialPortfolio: true,
    status: 'ACTIVE',
    sortOrder: 13,
    clientName: 'Yatağan Yol Yardım',
    createdAt: 1706100000000,
    updatedAt: 1711100000000,
  },
  {
    id: 'port_cinarrestaurant',
    title: 'Çınar Restaurant Dalaman',
    slug: 'cinarrestaurantdalaman',
    category: 'Restoran & Gastronomi',
    description: 'Geleneksel lezzetler, serpme köy kahvaltısı ve özel davetler için dijital menü ve rezervasyon platformu.',
    url: 'https://cinarrestaurantdalaman.com/',
    thumbnail: 'https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?q=80&w=800&auto=format&fit=crop',
    featured: false,
    projectType: 'website',
    technologies: ['QR Menü Uyumlu', 'Rezervasyon Formu', 'Galeri'],
    isOfficialPortfolio: true,
    status: 'ACTIVE',
    sortOrder: 14,
    clientName: 'Çınar Restaurant',
    createdAt: 1706200000000,
    updatedAt: 1711200000000,
  },
  {
    id: 'port_esfateknik',
    title: 'ESFA Teknik',
    slug: 'esfateknik',
    category: 'Mekanik & Havalandırma',
    description: 'Merkezi iklimlendirme, endüstriyel soğutma sistemleri ve mekanik tesisat mühendislik tanıtım sitesi.',
    url: 'https://www.esfateknik.com/',
    thumbnail: 'https://images.unsplash.com/photo-1621905251189-08b45d6a269e?q=80&w=800&auto=format&fit=crop',
    featured: false,
    projectType: 'website',
    technologies: ['Kurumsal Çözümler', 'Teknik Şartname Kataloğu', 'İletişim'],
    isOfficialPortfolio: true,
    status: 'ACTIVE',
    sortOrder: 15,
    clientName: 'ESFA Teknik Mühendislik',
    createdAt: 1706300000000,
    updatedAt: 1711300000000,
  },
  {
    id: 'port_enhavuz',
    title: 'En Havuz',
    slug: 'enhavuz',
    category: 'Havuz Sistemleri & Bakım',
    description: 'Yüzme havuzu inşaatı, filtrasyon sistemleri ve periyodik kimyasal bakım hizmetleri kurumsal web sitesi.',
    url: 'http://www.enhavuz.com/',
    thumbnail: 'https://images.unsplash.com/photo-1576013551627-0cc20b96c2a7?q=80&w=800&auto=format&fit=crop',
    featured: false,
    projectType: 'website',
    technologies: ['Proje Galerisi', 'Hizmet Detayları', 'Keşif Talep Formu'],
    isOfficialPortfolio: true,
    status: 'ACTIVE',
    sortOrder: 16,
    clientName: 'En Havuz Sistemleri',
    createdAt: 1706400000000,
    updatedAt: 1711400000000,
  },
  {
    id: 'port_ortacacamfilmi',
    title: 'Ortaca Cam Filmi',
    slug: 'ortacacamfilmi',
    category: 'Oto & Cam Filmi',
    description: 'Ortaca ve Köyceğiz bölgesinde araç, konut ve ofis cam filmi kaplama hizmetleri tanıtım platformu.',
    url: 'https://www.ortacacamfilmi.com/',
    thumbnail: 'https://images.unsplash.com/photo-1503376780353-7e6692767b70?q=80&w=800&auto=format&fit=crop',
    featured: false,
    projectType: 'website',
    technologies: ['Hızlı Teklif', 'Uygulama Görselleri', 'WhatsApp Hattı'],
    isOfficialPortfolio: true,
    status: 'ACTIVE',
    sortOrder: 17,
    clientName: 'Ortaca Cam Filmi',
    createdAt: 1706500000000,
    updatedAt: 1711500000000,
  },
  {
    id: 'port_turkcell',
    title: 'Turkcell',
    slug: 'turkcell-kurumsal-cozum',
    category: 'Kurumsal Dijital Çözüm',
    description: 'Turkcell kurumsal ekosistemi için gerçekleştirilen dijital altyapı ve özel yazılım geliştirme çalışmaları.',
    thumbnail: 'https://images.unsplash.com/photo-1451187580459-43490279c0fa?q=80&w=800&auto=format&fit=crop',
    featured: false,
    projectType: 'custom_software',
    technologies: ['Kurumsal API', 'Yüksek Güvenlikli Mimari', 'Bulut Entegrasyonu'],
    isOfficialPortfolio: true,
    status: 'ACTIVE',
    sortOrder: 18,
    clientName: 'Turkcell Kurumsal',
    createdAt: 1706600000000,
    updatedAt: 1711600000000,
  },
];
